import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setRefLink } from '../state/general/generalSlice';

const useRefLink = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const { search } = window.location;
        if (search) {
            dispatch(setRefLink(search));
        }
    }, []);
};
export default useRefLink;
